/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.GeneralSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The GeneralSettings model module.
   * @module model/GeneralSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>GeneralSettings</code>.
   * @alias module:model/GeneralSettings
   * @class
   */
  var exports = function() {
    var _this = this;

















































  };

  /**
   * Constructs a <code>GeneralSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GeneralSettings} obj Optional instance to populate.
   * @return {module:model/GeneralSettings} The populated <code>GeneralSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('UseLegalEntityCalculation')) {
        obj['UseLegalEntityCalculation'] = ApiClient.convertToType(data['UseLegalEntityCalculation'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyLogoURI')) {
        obj['CompanyLogoURI'] = ApiClient.convertToType(data['CompanyLogoURI'], 'String');
      }
      if (data.hasOwnProperty('FiscalPeriodStartMonth')) {
        obj['FiscalPeriodStartMonth'] = ApiClient.convertToType(data['FiscalPeriodStartMonth'], 'Integer');
      }
      if (data.hasOwnProperty('LastFinancialPeriodTypeID')) {
        obj['LastFinancialPeriodTypeID'] = ApiClient.convertToType(data['LastFinancialPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('LastFinancialPeriodRollingMonthOffset')) {
        obj['LastFinancialPeriodRollingMonthOffset'] = ApiClient.convertToType(data['LastFinancialPeriodRollingMonthOffset'], 'Integer');
      }
      if (data.hasOwnProperty('LastFinancialPeriodRollingDay')) {
        obj['LastFinancialPeriodRollingDay'] = ApiClient.convertToType(data['LastFinancialPeriodRollingDay'], 'Integer');
      }
      if (data.hasOwnProperty('LastFinancialPeriodDate')) {
        obj['LastFinancialPeriodDate'] = ApiClient.convertToType(data['LastFinancialPeriodDate'], 'Date');
      }
      if (data.hasOwnProperty('AggregatedFinancialCalculcateAll')) {
        obj['AggregatedFinancialCalculcateAll'] = ApiClient.convertToType(data['AggregatedFinancialCalculcateAll'], 'Boolean');
      }
      if (data.hasOwnProperty('AttachmentFileData')) {
        obj['AttachmentFileData'] = ApiClient.convertToType(data['AttachmentFileData'], 'String');
      }
      if (data.hasOwnProperty('CorporateCalculation')) {
        obj['CorporateCalculation'] = ApiClient.convertToType(data['CorporateCalculation'], 'Boolean');
      }
      if (data.hasOwnProperty('AdvisorPromotionalText')) {
        obj['AdvisorPromotionalText'] = ApiClient.convertToType(data['AdvisorPromotionalText'], 'String');
      }
      if (data.hasOwnProperty('AdvisorPromotionalURI')) {
        obj['AdvisorPromotionalURI'] = ApiClient.convertToType(data['AdvisorPromotionalURI'], 'String');
      }
      if (data.hasOwnProperty('MicrosoftTenantIdentifier')) {
        obj['MicrosoftTenantIdentifier'] = ApiClient.convertToType(data['MicrosoftTenantIdentifier'], 'String');
      }
      if (data.hasOwnProperty('PerformanceManagementAlertEvaluationInterval')) {
        obj['PerformanceManagementAlertEvaluationInterval'] = ApiClient.convertToType(data['PerformanceManagementAlertEvaluationInterval'], 'Integer');
      }
      if (data.hasOwnProperty('DefaultLanguageID')) {
        obj['DefaultLanguageID'] = ApiClient.convertToType(data['DefaultLanguageID'], 'Integer');
      }
      if (data.hasOwnProperty('GlobalErrorMessage')) {
        obj['GlobalErrorMessage'] = ApiClient.convertToType(data['GlobalErrorMessage'], 'String');
      }
      if (data.hasOwnProperty('IndicatorCalculationRunning')) {
        obj['IndicatorCalculationRunning'] = ApiClient.convertToType(data['IndicatorCalculationRunning'], 'Boolean');
      }
      if (data.hasOwnProperty('IndicatorValidationRunning')) {
        obj['IndicatorValidationRunning'] = ApiClient.convertToType(data['IndicatorValidationRunning'], 'Boolean');
      }
      if (data.hasOwnProperty('LastSalesPeriodTypeID')) {
        obj['LastSalesPeriodTypeID'] = ApiClient.convertToType(data['LastSalesPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('LastSalesPeriodDate')) {
        obj['LastSalesPeriodDate'] = ApiClient.convertToType(data['LastSalesPeriodDate'], 'Date');
      }
      if (data.hasOwnProperty('LastSalesPeriodRollingMonthOffset')) {
        obj['LastSalesPeriodRollingMonthOffset'] = ApiClient.convertToType(data['LastSalesPeriodRollingMonthOffset'], 'Integer');
      }
      if (data.hasOwnProperty('LastSalesPeriodRollingDay')) {
        obj['LastSalesPeriodRollingDay'] = ApiClient.convertToType(data['LastSalesPeriodRollingDay'], 'Integer');
      }
      if (data.hasOwnProperty('RequestMilestoneStatusUpdates')) {
        obj['RequestMilestoneStatusUpdates'] = ApiClient.convertToType(data['RequestMilestoneStatusUpdates'], 'Boolean');
      }
      if (data.hasOwnProperty('StrategyOnboardingDone')) {
        obj['StrategyOnboardingDone'] = ApiClient.convertToType(data['StrategyOnboardingDone'], 'Boolean');
      }
      if (data.hasOwnProperty('StrategyExecutionTypeID')) {
        obj['StrategyExecutionTypeID'] = ApiClient.convertToType(data['StrategyExecutionTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyPublishingLevelID')) {
        obj['StrategyPublishingLevelID'] = ApiClient.convertToType(data['StrategyPublishingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyAllowNotAlignedBreakthrough')) {
        obj['StrategyAllowNotAlignedBreakthrough'] = ApiClient.convertToType(data['StrategyAllowNotAlignedBreakthrough'], 'Boolean');
      }
      if (data.hasOwnProperty('StrategyAllowUserInviteTypeID')) {
        obj['StrategyAllowUserInviteTypeID'] = ApiClient.convertToType(data['StrategyAllowUserInviteTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('PublicPagesEnabled')) {
        obj['PublicPagesEnabled'] = ApiClient.convertToType(data['PublicPagesEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('MilestoneStatusUpdateDay')) {
        obj['MilestoneStatusUpdateDay'] = ApiClient.convertToType(data['MilestoneStatusUpdateDay'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyTertialPeriodStartMonth')) {
        obj['StrategyTertialPeriodStartMonth'] = ApiClient.convertToType(data['StrategyTertialPeriodStartMonth'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyQuarterPeriodStartMonth')) {
        obj['StrategyQuarterPeriodStartMonth'] = ApiClient.convertToType(data['StrategyQuarterPeriodStartMonth'], 'Integer');
      }
      if (data.hasOwnProperty('DefaultStrategicProgramUpdateFrequencyID')) {
        obj['DefaultStrategicProgramUpdateFrequencyID'] = ApiClient.convertToType(data['DefaultStrategicProgramUpdateFrequencyID'], 'Integer');
      }
      if (data.hasOwnProperty('GoalInstructionTextEN')) {
        obj['GoalInstructionTextEN'] = ApiClient.convertToType(data['GoalInstructionTextEN'], 'String');
      }
      if (data.hasOwnProperty('GoalInstructionTextFI')) {
        obj['GoalInstructionTextFI'] = ApiClient.convertToType(data['GoalInstructionTextFI'], 'String');
      }
      if (data.hasOwnProperty('GoalInstructionText')) {
        obj['GoalInstructionText'] = ApiClient.convertToType(data['GoalInstructionText'], 'String');
      }
      if (data.hasOwnProperty('MilestoneInstructionTextEN')) {
        obj['MilestoneInstructionTextEN'] = ApiClient.convertToType(data['MilestoneInstructionTextEN'], 'String');
      }
      if (data.hasOwnProperty('MilestoneInstructionTextFI')) {
        obj['MilestoneInstructionTextFI'] = ApiClient.convertToType(data['MilestoneInstructionTextFI'], 'String');
      }
      if (data.hasOwnProperty('MilestoneInstructionText')) {
        obj['MilestoneInstructionText'] = ApiClient.convertToType(data['MilestoneInstructionText'], 'String');
      }
      if (data.hasOwnProperty('StatusUpdateInstructionTextEN')) {
        obj['StatusUpdateInstructionTextEN'] = ApiClient.convertToType(data['StatusUpdateInstructionTextEN'], 'String');
      }
      if (data.hasOwnProperty('StatusUpdateInstructionTextFI')) {
        obj['StatusUpdateInstructionTextFI'] = ApiClient.convertToType(data['StatusUpdateInstructionTextFI'], 'String');
      }
      if (data.hasOwnProperty('StatusUpdateInstructionText')) {
        obj['StatusUpdateInstructionText'] = ApiClient.convertToType(data['StatusUpdateInstructionText'], 'String');
      }
      if (data.hasOwnProperty('BusinessReviewInstructionTextEN')) {
        obj['BusinessReviewInstructionTextEN'] = ApiClient.convertToType(data['BusinessReviewInstructionTextEN'], 'String');
      }
      if (data.hasOwnProperty('BusinessReviewInstructionTextFI')) {
        obj['BusinessReviewInstructionTextFI'] = ApiClient.convertToType(data['BusinessReviewInstructionTextFI'], 'String');
      }
      if (data.hasOwnProperty('DefaultStrategyNamingTypeID')) {
        obj['DefaultStrategyNamingTypeID'] = ApiClient.convertToType(data['DefaultStrategyNamingTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('BusinessReviewInstructionText')) {
        obj['BusinessReviewInstructionText'] = ApiClient.convertToType(data['BusinessReviewInstructionText'], 'String');
      }
      if (data.hasOwnProperty('TrackMilestoneStatusUpdatesOnPeriodLevel')) {
        obj['TrackMilestoneStatusUpdatesOnPeriodLevel'] = ApiClient.convertToType(data['TrackMilestoneStatusUpdatesOnPeriodLevel'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} UseLegalEntityCalculation
   */
  exports.prototype['UseLegalEntityCalculation'] = undefined;
  /**
   * @member {String} CompanyLogoURI
   * @default ''
   */
  exports.prototype['CompanyLogoURI'] = '';
  /**
   * @member {Integer} FiscalPeriodStartMonth
   * @default 0
   */
  exports.prototype['FiscalPeriodStartMonth'] = 0;
  /**
   * @member {Integer} LastFinancialPeriodTypeID
   */
  exports.prototype['LastFinancialPeriodTypeID'] = undefined;
  /**
   * @member {Integer} LastFinancialPeriodRollingMonthOffset
   */
  exports.prototype['LastFinancialPeriodRollingMonthOffset'] = undefined;
  /**
   * @member {Integer} LastFinancialPeriodRollingDay
   */
  exports.prototype['LastFinancialPeriodRollingDay'] = undefined;
  /**
   * @member {Date} LastFinancialPeriodDate
   */
  exports.prototype['LastFinancialPeriodDate'] = undefined;
  /**
   * @member {Boolean} AggregatedFinancialCalculcateAll
   * @default false
   */
  exports.prototype['AggregatedFinancialCalculcateAll'] = false;
  /**
   * @member {String} AttachmentFileData
   * @default ''
   */
  exports.prototype['AttachmentFileData'] = '';
  /**
   * @member {Boolean} CorporateCalculation
   * @default false
   */
  exports.prototype['CorporateCalculation'] = false;
  /**
   * @member {String} AdvisorPromotionalText
   * @default ''
   */
  exports.prototype['AdvisorPromotionalText'] = '';
  /**
   * @member {String} AdvisorPromotionalURI
   * @default ''
   */
  exports.prototype['AdvisorPromotionalURI'] = '';
  /**
   * @member {String} MicrosoftTenantIdentifier
   * @default ''
   */
  exports.prototype['MicrosoftTenantIdentifier'] = '';
  /**
   * @member {Integer} PerformanceManagementAlertEvaluationInterval
   */
  exports.prototype['PerformanceManagementAlertEvaluationInterval'] = undefined;
  /**
   * @member {Integer} DefaultLanguageID
   * @default 0
   */
  exports.prototype['DefaultLanguageID'] = 0;
  /**
   * @member {String} GlobalErrorMessage
   * @default ''
   */
  exports.prototype['GlobalErrorMessage'] = '';
  /**
   * @member {Boolean} IndicatorCalculationRunning
   * @default false
   */
  exports.prototype['IndicatorCalculationRunning'] = false;
  /**
   * @member {Boolean} IndicatorValidationRunning
   * @default false
   */
  exports.prototype['IndicatorValidationRunning'] = false;
  /**
   * @member {Integer} LastSalesPeriodTypeID
   * @default 0
   */
  exports.prototype['LastSalesPeriodTypeID'] = 0;
  /**
   * @member {Date} LastSalesPeriodDate
   */
  exports.prototype['LastSalesPeriodDate'] = undefined;
  /**
   * @member {Integer} LastSalesPeriodRollingMonthOffset
   */
  exports.prototype['LastSalesPeriodRollingMonthOffset'] = undefined;
  /**
   * @member {Integer} LastSalesPeriodRollingDay
   */
  exports.prototype['LastSalesPeriodRollingDay'] = undefined;
  /**
   * @member {Boolean} RequestMilestoneStatusUpdates
   * @default false
   */
  exports.prototype['RequestMilestoneStatusUpdates'] = false;
  /**
   * @member {Boolean} StrategyOnboardingDone
   * @default false
   */
  exports.prototype['StrategyOnboardingDone'] = false;
  /**
   * @member {Integer} StrategyExecutionTypeID
   * @default 0
   */
  exports.prototype['StrategyExecutionTypeID'] = 0;
  /**
   * @member {Integer} StrategyPublishingLevelID
   * @default 0
   */
  exports.prototype['StrategyPublishingLevelID'] = 0;
  /**
   * @member {Boolean} StrategyAllowNotAlignedBreakthrough
   * @default false
   */
  exports.prototype['StrategyAllowNotAlignedBreakthrough'] = false;
  /**
   * @member {Integer} StrategyAllowUserInviteTypeID
   */
  exports.prototype['StrategyAllowUserInviteTypeID'] = undefined;
  /**
   * @member {Boolean} PublicPagesEnabled
   * @default false
   */
  exports.prototype['PublicPagesEnabled'] = false;
  /**
   * @member {Integer} MilestoneStatusUpdateDay
   * @default 0
   */
  exports.prototype['MilestoneStatusUpdateDay'] = 0;
  /**
   * @member {Integer} StrategyTertialPeriodStartMonth
   * @default 0
   */
  exports.prototype['StrategyTertialPeriodStartMonth'] = 0;
  /**
   * @member {Integer} StrategyQuarterPeriodStartMonth
   * @default 0
   */
  exports.prototype['StrategyQuarterPeriodStartMonth'] = 0;
  /**
   * @member {Integer} DefaultStrategicProgramUpdateFrequencyID
   * @default 0
   */
  exports.prototype['DefaultStrategicProgramUpdateFrequencyID'] = 0;
  /**
   * @member {String} GoalInstructionTextEN
   * @default ''
   */
  exports.prototype['GoalInstructionTextEN'] = '';
  /**
   * @member {String} GoalInstructionTextFI
   * @default ''
   */
  exports.prototype['GoalInstructionTextFI'] = '';
  /**
   * @member {String} GoalInstructionText
   * @default ''
   */
  exports.prototype['GoalInstructionText'] = '';
  /**
   * @member {String} MilestoneInstructionTextEN
   * @default ''
   */
  exports.prototype['MilestoneInstructionTextEN'] = '';
  /**
   * @member {String} MilestoneInstructionTextFI
   * @default ''
   */
  exports.prototype['MilestoneInstructionTextFI'] = '';
  /**
   * @member {String} MilestoneInstructionText
   * @default ''
   */
  exports.prototype['MilestoneInstructionText'] = '';
  /**
   * @member {String} StatusUpdateInstructionTextEN
   * @default ''
   */
  exports.prototype['StatusUpdateInstructionTextEN'] = '';
  /**
   * @member {String} StatusUpdateInstructionTextFI
   * @default ''
   */
  exports.prototype['StatusUpdateInstructionTextFI'] = '';
  /**
   * @member {String} StatusUpdateInstructionText
   * @default ''
   */
  exports.prototype['StatusUpdateInstructionText'] = '';
  /**
   * @member {String} BusinessReviewInstructionTextEN
   * @default ''
   */
  exports.prototype['BusinessReviewInstructionTextEN'] = '';
  /**
   * @member {String} BusinessReviewInstructionTextFI
   * @default ''
   */
  exports.prototype['BusinessReviewInstructionTextFI'] = '';
  /**
   * @member {Integer} DefaultStrategyNamingTypeID
   * @default 0
   */
  exports.prototype['DefaultStrategyNamingTypeID'] = 0;
  /**
   * @member {String} BusinessReviewInstructionText
   * @default ''
   */
  exports.prototype['BusinessReviewInstructionText'] = '';
  /**
   * @member {Boolean} TrackMilestoneStatusUpdatesOnPeriodLevel
   * @default false
   */
  exports.prototype['TrackMilestoneStatusUpdatesOnPeriodLevel'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


